import React from 'react'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { number, object, setLocale, string } from 'yup'
import { Col, Form, notification, Row } from 'antd'
import { Button, Modal } from 'src/components/Ant'
import { Id } from 'src/types'
import { InputNumber, Select } from 'src/components/Formik'
import { updateRequestStatusSinc } from 'src/services/api/requests'
import * as CSS from './styles'

interface Props {
  toggle: () => void
  visible: boolean
  organizationId: Id
}

function getValidationSchema() {
  setLocale({
    mixed: {
      notType: 'common.required',
      required: 'common.required'
    }
  })
  return object().shape({
    request_number: number().min(1, 'common.required').required(),
    integration: string().required().typeError()
  })
}

function getInitialValues() {
  return {
    request_number: '',
    integration: 'NOT_SYNC'
  }
}

const options = [
  { label: 'Não integrado', title: 'Não integrado', value: `NOT_SYNC` },
  { label: 'Integrado', title: 'Integrado', value: `SYNC` },
  {
    label: 'Integração finalizada',
    title: 'Integração finalizada',
    value: `END_SYNC`
  }
]
function ModalIntegrationUpdate({
  visible,
  toggle,
  organizationId
}: Props): JSX.Element {
  const { t } = useTranslation()
  return (
    <>
      <Modal
        cancelButtonProps={{ hidden: true }}
        destroyOnClose
        maskClosable
        okButtonProps={{ hidden: true }}
        onCancel={toggle}
        onOk={() => {}}
        title="web.integration.integration-adjustment"
        visible={visible}
        width={500}
      >
        <Formik
          initialValues={getInitialValues()}
          onSubmit={async values => {
            if (!values) return

            const response = await updateRequestStatusSinc({
              integration: values.integration,
              organizationId,
              request_number: values.request_number
            })
            if (response.status !== 200) {
              notification.error({
                message: t('common.response.status-500'),
                placement: 'bottomRight'
              })
              return
            }

            notification.success({
              message: t('common.edit-done-successfully'),
              placement: 'bottomRight'
            })
          }}
          render={formikProps => (
            <>
              <Form onSubmit={formikProps.handleSubmit}>
                <Row>
                  <Col span={10}>
                    <InputNumber
                      dataTestId="request-number-title"
                      formikProps={formikProps}
                      label="web.reports.parameter.request_number.title"
                      min={0}
                      name="request_number"
                      placeholder="web.reports.parameter.request_number.placeholder"
                      required
                    />
                  </Col>
                  <Col offset={1} span={13}>
                    <Select
                      dataTestId="integration-value"
                      formikProps={formikProps}
                      label="web.integration.integration-to"
                      name="integration"
                      options={options}
                      required
                    />
                  </Col>
                </Row>
              </Form>
              <CSS.Div>
                <Button
                  title="common.actions.cancel"
                  type="default"
                  onClick={toggle}
                />
                <Button
                  title="web.closings.accept"
                  type="primary"
                  onClick={formikProps.submitForm}
                />
              </CSS.Div>
            </>
          )}
          validateOnBlur
          validationSchema={getValidationSchema()}
        />
      </Modal>
    </>
  )
}

export default ModalIntegrationUpdate
